import React from 'react'
import {Text, TextPriority, TextTypography} from 'wix-ui-tpa/cssVars'

export const EmptyCategory = () => {
  // TODO: not finished

  return (
    <div style={{textAlign: 'center', paddingTop: 20}}>
      <div>
        <Text tagName="h2" typography={TextTypography.smallTitle} priority={TextPriority.primary}>
          No available events
        </Text>
      </div>
      <div>
        <Text priority={TextPriority.secondary}>Try new filters</Text>
      </div>
    </div>
  )
}
